import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ChartFWPIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M6.52926 12.3209H3.88761V15.0494H2.5116V8.37207H6.85956V9.48665H3.88761V11.211H6.52926V12.3209ZM12.8583 13.1231L13.7568 8.37207H15.1281L13.6472 15.0494H12.2618L11.1747 10.5825L10.0883 15.0494H8.70285L7.22196 8.37207H8.59327L9.49652 13.1137L10.597 8.37285H11.7617L12.8575 13.1239L12.8583 13.1231ZM17.2469 12.6966V15.0494H15.8709V8.37207H18.4758C18.9775 8.37207 19.419 8.46365 19.7986 8.6468C20.1798 8.83074 20.4725 9.09138 20.6776 9.42951C20.8826 9.76686 20.9852 10.1512 20.9852 10.5825C20.9852 11.2368 20.7605 11.7526 20.3128 12.1307C19.8651 12.5079 19.2452 12.6966 18.4531 12.6966H17.2477H17.2469ZM17.2469 11.582H18.4758C18.8398 11.582 19.1176 11.4959 19.3086 11.3252C19.4996 11.1538 19.5951 10.9096 19.5951 10.5918C19.5951 10.2647 19.4988 10.0001 19.3063 9.79817C19.1137 9.59623 18.8476 9.49291 18.5079 9.48665H17.2477V11.582H17.2469Z'
                fill='currentColor'
            />
        </>
    ),
})

ChartFWPIcon.displayName = 'ChartFWPIcon'
